import { Icon, ICONS, PLATFORM_THEME_COLORS, Popover } from '@thinknet-gmbh/platform-common-ui';
import { PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { IEmployee } from 'src/pages/employee/employee.interfaces';
import { useUserCanManageDocument } from 'src/hooks/user-can-manage-document.hook';

interface IProps {
  record: any;
  deleteEmployee: (record: IEmployee) => void;
}

const EmployeeTableAction: FC<IProps> = ({ record, deleteEmployee }) => {
  const { t } = useTranslation('employee');
  const navigate = useNavigate();

  const { canDelete } = useUserCanManageDocument({
    createdBy: record.createdBy || '',
    platformPermission: PLATFORM_PERMISSIONS.employeeManagement,
  });

  return (
    <Popover
      trigger="hover"
      elements={[
        {
          label: t('labels.viewDetails'),
          icon: ICONS.foodMenu,
          key: ICONS.foodMenu,
          handler: () => navigate(`${ROUTES.employee}/${record._id}`),
        },

        {
          label: t('deleteModal.title'),
          icon: ICONS.trash,
          key: ICONS.trash,
          color: canDelete
            ? PLATFORM_THEME_COLORS.tone.red
            : PLATFORM_THEME_COLORS.grayVariations.medium,
          handler: () => canDelete && deleteEmployee(record),
        },
      ]}
    >
      <Icon
        size={22}
        icon={ICONS.dotsVerticalRounded}
        color={PLATFORM_THEME_COLORS.primary.grey}
        rightMargin={false}
      />
    </Popover>
  );
};

export default EmployeeTableAction;
